import React, { Component } from 'react';
import { Label, FormGroup, Input, FormText } from 'reactstrap';

class BackLink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customLinkEnabled: props.url && props.url.length > 0,
      url: props.url,
      text: props.text,
      enabled: props.enabled
    };
  }

  render() {
    const { updateBacklink } = this.props;
    const { customLinkEnabled, url, text, enabled } = this.state;
    return (
      <div className={'mb-4'}>
        <FormGroup className="flex-100 position-relative form-group">
          <Label for={'back-link-enabled'} check className="switch-toggle">
            <Input
              type="checkbox"
              checked={enabled}
              onChange={e => {
                this.setState({ enabled: e.target.checked });
                updateBacklink({ enabled: e.target.checked });
              }}
              id={'back-link-enabled'}
            />
            <div className="slider" />
            <span>Show Back Link</span>
          </Label>
          <FormText color="muted">
            Links to the landing page by default
          </FormText>
        </FormGroup>

        {enabled && (
          <FormGroup className={'ml-4'}>
            <Label check>
              <Input
                onChange={e => {
                  if (!e.target.checked) {
                    updateBacklink({
                      url: '',
                      text: ''
                    });
                    this.setState({ url: '', text: '' });
                  }
                  this.setState({ customLinkEnabled: e.target.checked });
                }}
                id="customLinkEnabled"
                type="checkbox"
                checked={customLinkEnabled}
              />
              Specify custom link
            </Label>
          </FormGroup>
        )}
        {customLinkEnabled && enabled && (
          <React.Fragment>
            <FormGroup>
              <Label for="back-link-url">Link url</Label>
              <Input
                id="back-link-url"
                onChange={e => {
                  this.setState({ url: e.target.value });
                  updateBacklink({
                    url: e.target.value,
                    text: this.state.text
                  });
                }}
                value={url || ''}
                placeholder="Enter relative or absolute URL"
              />
            </FormGroup>
            <FormGroup>
              <Label for="back-link-text">Link text</Label>
              <Input
                id="back-link-text"
                onChange={e => {
                  this.setState({ text: e.target.value });
                  updateBacklink({ text: e.target.value, url: this.state.url });
                }}
                value={text || ''}
                placeholder="Enter custom link text (e.g. Back to Apple Store)"
              />
            </FormGroup>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default BackLink;



// WEBPACK FOOTER //
// ./src/components/library/BackLink/BackLink.js